// Small display helpers shared across the timetable surfaces.
//
// These lived as private copies in individual pages — WEEKDAY_KEY alone had
// five — which is how a weekday table gets reordered in one place and quietly
// mislabels a day in another.

// JS Date.getDay() order (0 = Sunday … 6 = Saturday), matching the backend and
// TeacherTimetableEntry. Never remap: the whole scheduling surface indexes on it.
export const WEEKDAY_KEY = {
  0: "sun", 1: "mon", 2: "tue", 3: "wed", 4: "thu", 5: "fri", 6: "sat",
};

export const weekdayKey = (weekday) => WEEKDAY_KEY[weekday] ?? "sun";

// `naturalCompare` moved to ./locale — it needs the UI language to sort Kazakh
// correctly, and it is used well outside the timetable surfaces.

// "Oliver Russell" -> "O. Russell". A summary cell is about 45px wide, so the
// full name truncates to "Oli…" and identifies nobody; the surname is the part
// that does.
export const shortName = (name) => {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length < 2) return parts[0] || "";
  return `${parts[0][0]}. ${parts[parts.length - 1]}`;
};

// A paginated list endpoint may answer either an array or a DRF envelope.
export const rowsOf = (data) => (Array.isArray(data) ? data : data?.results || []);

// Save a blob to disk. The anchor MUST be in the document for Firefox to honour
// the click, and the object URL is revoked rather than left to the GC — a few
// whole-school workbooks are megabytes each and would be pinned for the life of
// the tab.
export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
